export const wordKey = (word) => word.toLowerCase().replace(/[^a-z0-9]/g, "");

export const wordsOf = (text) => text.split(/\s+/).map(wordKey).filter(Boolean);
